// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Config from "../../Config.bs.js";
import * as InitializeGA4$Catalyst from "../../../node_modules/@porterin/catalyst/src/components/custom/event-tracker-ga4/react-ga4/initializer/InitializeGA4.bs.js";

function initGa4(service) {
  var measurement_id;
  switch (service) {
    case /* RnR */0 :
        measurement_id = Config.Env.getGa4RnrTrackingId(undefined);
        break;
    case /* PartnerApp */1 :
        measurement_id = Config.Env.getGa4TrackingId(undefined);
        break;
    case /* TrackLiveTrip */2 :
        measurement_id = Config.Env.getGa4TLTTrackingId(undefined);
        break;
    
  }
  return InitializeGA4$Catalyst.useGa4Initializer(true, measurement_id, "ga_4_lending");
}

export {
  initGa4 ,
  
}
/* Config Not a pure module */
